import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ListItemsSelectNavigationContainer from "@/components/layouts/ListItemsSelectNavigationContainer/ListItemsSelectNavigationContainer.vue";
import { GetterTypes } from "@/store";
import { getSettingsMenuItems, deleteUserAccountArray } from "@/utils/settings";
import { useComputedValue } from "@/composables";
import { Profile } from "@/store/auth/state";
import { IListItem } from "@/types/list";
import { getActivateAccountArray } from "@/utils/settings";
import { computed } from "vue";
import { getFullPhoneNumberString } from "@/utils/form";
import { getPhoneNumberStringWithSpaces } from "@/utils/modifiers";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsAll',
  setup(__props) {

const profile = useComputedValue<Profile>(GetterTypes.GET_AUTH_PROFILE);
const appliedNavigationTitle = computed<string>(() => {
  const { name, phoneNumber, countryCode, email } = profile.value;
  if (email) {
    return name;
  }
  const fullString = getFullPhoneNumberString(countryCode, phoneNumber);
  const phoneNumberStringWithSpaces =
    getPhoneNumberStringWithSpaces(fullString);
  return phoneNumberStringWithSpaces;
});
const activateAccountArray = computed<IListItem[]>(() =>
  getActivateAccountArray(),
);
const filteredSettingsMenuItems = computed<IListItem[]>(() => {
  return getSettingsMenuItems().filter(
    // some items to be hidden outside of webview container:
    (item) => {
      // but must be visible in local dev environment:
      if (process.env.VUE_APP_ENVIRONMENT) {
        return true;
      }
      return !item.isHidden;
    },
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsSelectNavigationContainer, {
    "navigation-title": appliedNavigationTitle.value,
    "lists-array": [
      activateAccountArray.value,
      filteredSettingsMenuItems.value,
      _unref(deleteUserAccountArray),
    ]
  }, null, 8, ["navigation-title", "lists-array"]))
}
}

})